export const defaultCutoffValues = {
  academicyear: { value: "AY202526", label: "AY202526" },
  board: { value: "JOSAA", label: "JOSAA" },
  round: { value: "R1", label: "R1" },
  quota: { value: "AI", label: "AI" },
  category: { value: "OPEN", label: "OPEN" },
  gender: { value: "GENDER-NEUTRAL", label: "GENDER-NEUTRAL" },
};
export const defaultCutoffSearch = {
  academicyear: "AY202526",
  board: "JOSAA",
  round: "R1",
  quota: "AI",
  category: "OPEN",
  gender: "GENDER-NEUTRAL",
};

export const mainCutoffList = ["academicyear", "board", "round", "quota", "category",'gender'];